









































import { LangSwitcher } from "@/components/LangSwitcher";
import { Actions } from "@/models/constant/enums/actions.enum";
import { Component, Vue } from "vue-property-decorator";
import { mapActions, mapMutations } from "vuex";

@Component({
  components: {
    LangSwitcher,
  },
  methods: {
    ...mapMutations({
      setStore: "set",
    }),
    ...mapActions({
      logout: Actions.ACTIONS_LOGOUT,
    }),
  },
})
export default class AppHeader extends Vue {
  setStore!: (payload: [state: string, value: any]) => void;
  logout!: () => void;

  get icon(): string {
    return this.$store.state.sidebarMinimize ? "menu-unfold" : "menu-fold";
  }

  get companyLogo(): string {
    return this.$sanitize(
      this.$store.state.authStore.authData.companyLogo ??
        "../../assets/image/logo.png"
    );
  }

  get companyName(): string {
    return this.$store.state.authStore.authData.companyName ?? "-";
  }

  toggleMenu(): void {
    this.setStore(["sidebarMinimize", !this.$store.state.sidebarMinimize]);
  }

  handleLogout(): void {
    this.$confirm({
      title: this.$t("lbl_confirmation"),
      content: this.$t("lbl_logout_confirmation"),
      onOk: () => {
        this.logout();
      },
    });
  }
}
